var map = {
	"./SprinkleZone-logo.svg": 626,
	"./all-nuggets.svg": 627,
	"./completed-nuggets.svg": 628,
	"./feedback.svg": 629,
	"./pending-nuggets.svg": 630,
	"./popular-nuggets.svg": 631,
	"./recently-added-nuggets.svg": 632,
	"./reports.svg": 633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 625;